//#region src/verticals/pricing/PricingEvent.ts
var e = /* @__PURE__ */ function(e) {
	return e.RuleCreated = "pricing.rule.created", e.RuleApplied = "pricing.rule.applied", e.RuleDeleted = "pricing.rule.deleted", e.OverrideApplied = "pricing.override.applied", e;
}({});
//#endregion
export { e as PricingEvent };
